import { useAppSelector } from "store/hooks";
import { DeleteWarningIcon } from "assets/svgs";
import { userSettingState } from "store/selectors";
import { CustomModal, Modal, Button, Headings } from "components/ui";

type DeleteConfirmationModalPropTypes = {
  showModal: boolean;
  onClose: () => void;
  onDelete: () => void;
  descriptionText: string;
};

export function DeleteConfirmationModal({
  showModal,
  onClose,
  onDelete,
  descriptionText,
}: DeleteConfirmationModalPropTypes) {
  const { isDarkMode } = useAppSelector(userSettingState);

  return (
    <CustomModal isOpen={showModal} onClose={onClose} classes="!max-w-[600px]">
      <Modal.Header title="Delete Confirmation" />
      <Modal.Body
        classes={`my-3 flex flex-col items-center ${
          isDarkMode ? "bg-dark-primary" : "bg-red-50"
        }`}
      >
        <DeleteWarningIcon className="w-10 h-10 fill-red-500 mb-3" />
        <Headings.LevelTwo classes="text-gray-700">
          Are you sure?
        </Headings.LevelTwo>
        <p
          className={`${
            isDarkMode ? "text-secondary" : "text-gray-500"
          } mx-auto text-center max-w-[400px]`}
        >
          {descriptionText}
        </p>
      </Modal.Body>

      <Modal.Footer classes="flex justify-center gap-2">
        <Button
          type="button"
          variant="green-out"
          className="w-full max-w-48 !py-3"
          onClick={onClose}
        >
          No
        </Button>
        <Button
          type="button"
          variant="green"
          className="w-full max-w-48 !py-3"
          onClick={onDelete}
        >
          Yes
        </Button>
      </Modal.Footer>
    </CustomModal>
  );
}
